<template>
  <el-button @click="createChat" size="mini">{{ btnText }}</el-button>
</template>

<script>
import base from '@/api/common';

export default {
  name: "shortChat",
  props: {
    userId: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      default: ''
    },
    btnText: { // 按钮文本
      type: String,
      default: '私信'
    }
  },
  data() {
    return {}
  },
  methods: {
    createChat() {
      if (!this.userId) {
        console.error('uid is null');
        return;
      }
      this.$ajax.post(base.api.communication.chat.create.replace('{uid}', this.userId)).then(res => {
            if (res.data.status === 'success') {
              if (res.data.userType == 1) {
                this.$router.push({name: 'communicate', params: {id: res.data.id}});
              } else if (res.data.userType == 2) {
                this.$ajax.post(base.api.communication.chat.isContacts.replace('{id}', this.userId)).then(resA => {
                  if (resA.data.status === 'success') {
                    if(resA.data.isContacts==false){
                      this.$message.warning('请先添加好友');
                    }else{
                      if(resA.data.contactsType==1){
                        this.$router.push({name: 'communicateDoc', params: {id: res.data.id}});
                      }else{
                        this.$message.warning('拒绝会话');
                      }
                    }
                  }
                })
              } else {
                this.$message.error('error');
              }
            } else {
              if(res.data.status === 'needApply'){
                this.$emit('handleNeedApply',this.userId, this.username);
              }
              this.$message.error(res.data.message);
            }
          }
      ).catch(err => {
        console.error(err);
        this.$message.error('失败');
      })
    }
  }
}
</script>

<style scoped>

</style>
